export default "__VITE_ASSET__DbMC9Hfy__"